module.exports = __webpack_public_path__ + "img/back-ground@3x.95ebe080.png";